import React, {Component} from 'react';
import ReactFlagsSelect from 'react-flags-select';
import * as Intl from "./Intl";
import Chart from './Chart';
import 'react-flags-select/css/react-flags-select.css';

const rp = require('request-promise');

const ITEMS = [
    'status-botmaker-api',
    'status-botmaker-console',
    'status-botmaker-webchat',
    'status-botmaker-messenger'
];

class App extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    componentDidMount() {
        this.setState({
            lang: 'en',
            country: this.getCountry('en'),
            status: null,
            loadTranslations: false
        });
        this.getDefaultCountry();
        this.refresh();

        setInterval(() => this.refresh(), (1000 * 60 * 2)); // 2 mins
    }

    getDefaultCountry() {
        rp({
            uri: 'https://m-infra.appspot.com/ip.jsp',
            json: true
        })
            .catch(err => console.error(err))
            .then(json => {
                let l;

                switch (json.country) {
                    case 'BR':
                    case 'PT':
                        l = 'pt';
                        break;

                    case 'ES':
                    case 'MX':
                    case 'CU':
                    case 'GT':
                    case 'HN':
                    case 'SV':
                    case 'NI':
                    case 'CR':
                    case 'PA':
                    case 'VE':
                    case 'CO':
                    case 'EC':
                    case 'PE':
                    case 'BO':
                    case 'CL':
                    case 'PY':
                    case 'UY':
                    case 'AR':
                        l = 'es';
                        break;

                    default:
                        l = 'en';
                }
                this.setState({lang: l, country: this.getCountry(l), loadTranslations: true});
                //this.refs.userFlag.updateSelected(this.getCountry(l));
            });
    }

    refresh() {
        rp({
            uri: 'https://us-central1-m-infra.cloudfunctions.net/statuspage',
            json: true
        })
            .then(json => {
                if (!json || Object.keys(json).length === 0) return;

                this.setState({status: json});
            })
            .catch(err => console.error(err));
    }

    text(k) {
        return Intl.intl[this.state.lang][k];
    }

    getCountry(lang) {
        switch (lang) {
            case 'en':
                return 'US';
            case 'pt':
                return 'BR';
            default:
                return 'ES';
        }
    }

    setLangFrom(country) {
        let l = 'es';

        if (country === 'US')
            l = 'en';
        if (country === 'BR')
            l = 'pt';

        this.setState({lang: l, country: this.getCountry(l)});
    }

    render() {
        const {status, loadTranslations, country} = this.state;

        if (!status)
            return <h5>Loading..</h5>;

        return <div>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                <img style={{margin: 10, height: 30}} src="//storage.googleapis.com/m-infra.appspot.com/public/botmaker/bmtop7.png" alt="BotMaker"/>

                <div style={{position: 'absolute', right: 0}}>
                    {loadTranslations && <ReactFlagsSelect
                        countries={["US", "BR", "ES"]}
                        customLabels={{"US": "en", "BR": "pt", "ES": "es"}}
                        defaultCountry={country}
                        showSelectedLabel={false}
                        alignOptions="left"
                        onSelect={r => this.setLangFrom(r)}
                    />}
                </div>
            </div>

            {ITEMS.map((k, idx) => <Chart
                key={'c_' + idx}
                title={k.substring(k.lastIndexOf('-') + 1)}
                data={status[k]}
                text={k => this.text(k)}
            />)}
        </div>;
    }
}

export default App;
